import { makeObservable, observable, action } from "mobx";

import { LabelValue } from "../../models/Dashboard/Analytics";
import CustomerExperienceDashboardAPI from "../../api/dashboards/CustomerExperienceDashboardAPI";
import {
  CustomerExperienceAPIFilters,
  CustomerExperienceFilters,
} from "../../models/Dashboard/CustomerExperienceDashboard/CustomerExperienceFilters";

export class CustomerExperienceAnalyticsDashboardStore {
  analyticsAPI: CustomerExperienceDashboardAPI;
  internal_feedback_tats: LabelValue[];
  customer_exp_feedback_tats: LabelValue[];
  department_wise_internal_broken_experience: LabelValue[];
  department_wise_customer_exp_broken_experience: LabelValue[];

  constructor() {
    this.analyticsAPI = new CustomerExperienceDashboardAPI();
    this.internal_feedback_tats = [];
    this.customer_exp_feedback_tats = [];
    this.department_wise_internal_broken_experience = [];
    this.department_wise_customer_exp_broken_experience = [];

    makeObservable(this, {
      internal_feedback_tats: observable,
      customer_exp_feedback_tats: observable,
      department_wise_internal_broken_experience: observable,
      department_wise_customer_exp_broken_experience: observable,
      getInternalFeedbackAnalyticsTats: action,
      getCustomerExpFeedbackAnalyticsTats: action,
      getDepartmentWiseInternalFeedbackBrokenExperience: action,
      getDepartmentWiseCustomerExpBrokenExperience: action,
    });
  }

  getInternalFeedbackAnalyticsTats = async (
    filters: CustomerExperienceAPIFilters
  ) => {
    try {
      const data = (await this.analyticsAPI.getTatsData(
        "tats/internal-feedback",
        filters
      )) as LabelValue[];
      this.internal_feedback_tats = data;
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };

  getCustomerExpFeedbackAnalyticsTats = async (
    filters: CustomerExperienceAPIFilters
  ) => {
    try {
      const data = (await this.analyticsAPI.getTatsData(
        "tats/customer-exp-feedback",
        filters
      )) as LabelValue[];
      this.customer_exp_feedback_tats = data;
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };

  getDepartmentWiseInternalFeedbackBrokenExperience = async (
    filters: CustomerExperienceAPIFilters
  ) => {
    try {
      const data = (await this.analyticsAPI.getTatsData(
        "tats/internal-feedback/department-wise/broken-exp-count",
        filters
      )) as LabelValue[];
      this.department_wise_internal_broken_experience = data;
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };

  getDepartmentWiseCustomerExpBrokenExperience = async (
    filters: CustomerExperienceAPIFilters
  ) => {
    try {
      const data = (await this.analyticsAPI.getTatsData(
        "tats/customer-exp-feedback/department-wise/broken-exp-count",
        filters
      )) as LabelValue[];
      this.department_wise_customer_exp_broken_experience = data;
    } catch (error) {
      console.error("Error fetching Data", error);
    }
  };
}
